import { motion } from "framer-motion";

export const Preloader = ({ logo, caption, logoClass = "w-56 sm:w-72", bg = "bg-brand-licorice" }) => (
  <motion.div
    data-testid="preloader"
    className={`fixed inset-0 z-[100] flex items-center justify-center ${bg}`}
    exit={{ y: "-100%" }}
    transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
  >
    <motion.img
      src={logo}
      alt=""
      className={logoClass}
      initial={{ opacity: 0, y: 18 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
    />
    <motion.span
      className="absolute bottom-10 text-[10px] font-medium uppercase tracking-[0.35em] text-brand-ivory/40"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.4, duration: 0.6 }}
    >
      {caption}
    </motion.span>
  </motion.div>
);
